<template>
  <button class="tutorial-button block absolute select-none" @click="onClick">
    <icon-info class="icon" />
  </button>
</template>

<script>
import IconInfo from "@/components/icons/IconInfo";
import Vue from "vue";

/**
 * The small info button in the top right corner
 */
export default {
  name: "TutorialButton",
  components: { IconInfo },
  props: {
    showBus: {
      type: Vue,
      default: null
    }
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
      if (this.showBus != null) {
        this.showBus.$emit("click", event);
      }
    }
  }
};
</script>
<style scoped>
.icon {
  font-size: 2.25rem;
}
.tutorial-button {
  width: 2.25rem;
  height: 2.25rem;
}
@media screen and (min-width: 768px) {
  .tutorial-button {
    width: 2.6875rem;
    height: 2.6875rem;
  }
  .icon {
    font-size: 2.6875rem;
  }
}
</style>
